import type { CardItemShelterProps } from '@presentation/components';
import { CardItem } from '@presentation/components';
import type { FC } from 'react';

export * from './types';

export const CardItemShelter: FC<CardItemShelterProps> = (props) => {
  const { image, name, location, languages, ...rest } = props;
  return (
    <CardItem
      image={image}
      content={{
        title: name,
        text: location,
      }}
      footer={languages}
      {...rest}
    />
  );
};
